module.exports = __webpack_public_path__ + "static/media/background-presentation-desktop.a1ca0f14.png";